import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppServiceService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-rating-feedback-widget-with-message',
  templateUrl: './rating-feedback-widget-with-message.component.html',
  styleUrls: ['./rating-feedback-widget-with-message.component.scss']
})
export class RatingFeedbackWidgetWithMessageComponent {
  selectedRating: number = 0;
  hoveredRating: number = 0;
  isRatingSubmited: boolean = false;

  styleSheet: CSSStyleSheet | undefined;

  showFeedBack: boolean = false;
  isPointerEventDisable: boolean = false;

  @Output() handleSubmitResponse = new EventEmitter<any>();
  @Output() scrollToBottom = new EventEmitter<any>();
  @Output() makeInputDisable = new EventEmitter<boolean>();
  @Output() makeInputEnable = new EventEmitter<boolean>();
  @Input() clientConfigurationId: string = '';
  @Input() sessionAttributes: any = {};

  @Input() clientConfigurationData: any;
  @Input() canChangeStyle: any;
  DATA: any;
  feedbackMessage: string = "";

  constructor(
    private appService: AppServiceService
  ) { }


  ngOnInit() {

    this.makeInputDisable.emit();

    if (this.canChangeStyle) {
      this.DATA = this.clientConfigurationData;
      this.fnSetStyles();
    } else {
      this.fnSetDefaultStyles();
    }
  }

  submitRating(value: number) {
    console.log('Rating submitted123', value);
    this.selectedRating = value;
    this.hoveredRating = value;
    this.isRatingSubmited = true;
    this.scrollToBottom.emit();
    this.makeInputDisable.emit();
  }

  handleSubmitFeedBack() {
    this.handleSubmitResponse.emit({
      type: "start_rating_input",
      text: this.feedbackMessage,
      value: JSON.stringify(this.selectedRating)
    });
    this.makeInputEnable.emit();
    this.isPointerEventDisable = true;
  }


  fnSetStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    let dialogColors = this.DATA.UserDialogBackgroundColor.split(";");
    let dialogPrimaryColor = dialogColors[0];
    let dialogGradientColor1 = dialogColors[1];
    let dialogGradientColor2 = dialogColors[2];

    this.styleSheet.insertRule(`.user-message {
      background: `+ dialogPrimaryColor + ` !important;	
      color: `+ this.DATA.UserDialogTextColor + ` !important;
    }`);

    this.styleSheet.insertRule(`.feedback-submit-btn {
      background: `+ this.DATA.PrimaryColor  + ` !important;	
    }`);



    this.styleSheet.insertRule(`.bot-message {
      background: `+ this.DATA.BotDialogBackgroundColor + ` !important;	
      color: `+ this.DATA.BotDialogTextColor + ` !important;
    }`);


    this.styleSheet.insertRule(`.bot-message > a {

      color: `+ this.DATA.BotDialogTextColor + ` !important;
    }`);

  }

  fnSetDefaultStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`.user-message {
      background: `+ '#156087' + ` !important;	
      color: `+ '#FFFFFF' + ` !important;
    }`);

    this.styleSheet.insertRule(`.bot-message {
      background: `+ '#ffffff' + ` !important;	
      color: `+ '#156087' + ` !important;
    }`);

    
    this.styleSheet.insertRule(`.feedback-submit-btn {
      background: `+ '#156087'  + ` !important;	
    }`);

    

  }

}
